<section class="service-section pt-3 pb-5">
  <div class="container">
    <div class="row service-boxes justify-content-center">
      <div
        class="col-lg-3 col-sm-6 col-10"
        *ngFor="let item of service; let i = index"
      >
        <div class="service-box-three" *transloco="let t; read: 'home'">
          <div class="icon">
            <img [src]="item.shadowicon" [alt]="t('list')[i].title" />
          </div>
          <h3>
            <a>{{ t("list")[i].title }}</a>
          </h3>
          <p>{{ t("list")[i].text }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
